import { createIcon } from '@chakra-ui/react';

export const Individual = createIcon({
  displayName: 'Individual',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect id="bg" width="24" height="24" fill="none" />
      <path
        id="Avatars_People_Individual_-_L"
        data-name="Avatars People Individual - L"
        d="M13.969,23.215a3.938,3.938,0,1,0-3.938-3.938A3.938,3.938,0,0,0,13.969,23.215Zm0-6.49a2.553,2.553,0,1,1-2.553,2.553A2.553,2.553,0,0,1,13.969,16.725ZM21.1,29.683l-.688-2.5a3.912,3.912,0,0,0-3.333-2.816,15.612,15.612,0,0,0-3.1-.36,15.645,15.645,0,0,0-3.116.36,3.912,3.912,0,0,0-3.333,2.816l-.688,2.507A1.3,1.3,0,0,0,8.1,31.34H19.841A1.3,1.3,0,0,0,21.1,29.7Zm-12.889.272.656-2.4a2.647,2.647,0,0,1,2.276-1.847,14.361,14.361,0,0,1,2.839-.332,14.029,14.029,0,0,1,2.821.332,2.6,2.6,0,0,1,2.276,1.847l.656,2.4Z"
        transform="translate(-1.968 -11.34)"
        fill="currentColor"
      />
    </>
  ),
});
